export const graphOptions = [
    {
        id: 'Text Chart',
        image: 'icon-fontsize',
        imageType: 'icon'
    },
    {
        id: 'Line Chart',
        image: 'icon-chart-line',
        imageType: 'icon'
    }
]